import React from 'react';
import { useCommonActionFromDALV2 } from '@shares/actionFormDALV2';
import { CommonNotificationSaveError } from '@shares/CommonNotification';
import { Icon, notification } from 'antd';
import { get } from 'lodash';
import { useAsyncFn } from 'react-use';
import { BIGDATA_CONSTANT } from '../../../../common/constant';
import DpemetasUpdateCacheAll from './api';

export type TUseDeletePZaloApp = {
  isLoading?: boolean;
  response?: any;
  handleReloadCache: () => Promise<any | undefined>;
};

const useDpemetasUpdateCacheAll = (): TUseDeletePZaloApp => {
  const commonActionFromDALV2 = useCommonActionFromDALV2();

  const [state, doFetch] = useAsyncFn(async () => {
    const response: Promise<any> = await commonActionFromDALV2(DpemetasUpdateCacheAll);
    const result = await response;
    if (result.success) {
      notification.success({
        message: BIGDATA_CONSTANT.message.default.title.success,
        description: `The cache reload request has been accepted and is currently being processed. Estimated time: ${result?.estimate} seconds`,
        icon: <Icon type='check-circle' style={{ color: 'var(--primary-color)' }} />,
      });
    } else {
      CommonNotificationSaveError(get(result, 'message', 'Somethings Went Wrong!'));
    }

    return result;
  }, []);

  return {
    response: state?.value,
    handleReloadCache: doFetch,
    isLoading: state.loading,
  };
};

export default useDpemetasUpdateCacheAll;
